module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Duplicate-6cdc1165eb924ea1f11b38a0e5fbaff1.svg";